import { CommercialClient } from "../models/CommercialClient";
import { ClientProcedure, IntranetClientFields, SaveClientProcedure } from "../models/Intranet";
import api from "./api";

export const getIntranetClients = async (search?: string): Promise<CommercialClient[]> =>
  (await api.get("/api/intranet/clients", { params: { search: search || undefined } })).data ?? [];

export const getIntranetClient = async (id: string): Promise<CommercialClient> =>
  (await api.get(`/api/intranet/clients/${id}`)).data;

export const updateIntranetClient = async (id: string, fields: IntranetClientFields) =>
  api.put(`/api/intranet/clients/${id}`, fields);

export const getClientProcedures = async (commercialClientId: string): Promise<ClientProcedure[]> =>
  (await api.get(`/api/intranet/clients/${commercialClientId}/procedures`)).data ?? [];

export const getGeneralProcedures = async (unitType?: number): Promise<ClientProcedure[]> =>
  (await api.get("/api/intranet/procedures", { params: { unitType } })).data ?? [];

export const createProcedure = async (procedure: SaveClientProcedure) =>
  api.post("/api/intranet/procedures", procedure);

export const updateProcedure = async (id: string, procedure: SaveClientProcedure) =>
  api.put(`/api/intranet/procedures/${id}`, procedure);

export const deleteProcedure = async (id: string) => api.delete(`/api/intranet/procedures/${id}`);

export const reorderProcedures = async (ids: string[]) => api.put("/api/intranet/procedures/reorder", { ids });

/** expectedUpdatedDate = data do rascunho aberto; a resposta traz procedureUpdatedDate só se ele ainda estava em dia. */
export const uploadProcedureAttachment = async (procedureId: string, file: File, expectedUpdatedDate?: string | null) => {
  const form = new FormData();
  form.append("file", file);
  return api.post(`/api/intranet/procedures/${procedureId}/attachments`, form, {
    headers: { "Content-Type": "multipart/form-data" },
    params: expectedUpdatedDate ? { expectedUpdatedDate } : undefined,
  });
};

export const deleteProcedureAttachment = async (id: string, expectedUpdatedDate?: string | null) =>
  api.delete(`/api/intranet/attachments/${id}`, { params: expectedUpdatedDate ? { expectedUpdatedDate } : undefined });

/** Baixa pelo axios (precisa do Bearer) e entrega ao navegador como arquivo. */
export const downloadProcedureAttachment = async (id: string, fileName: string) => {
  const response = await api.get(`/api/intranet/attachments/${id}`, { responseType: "blob" });
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const addIntranetClientComment = async (id: string, text: string) =>
  api.post(`/api/intranet/clients/${id}/comments`, { text });

export const previewNotionImport = async (file: File) => {
  const form = new FormData();
  form.append("file", file);
  return api.post("/api/intranet/import/preview", form, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 });
};

/** mapping: chave da ficha → id do cliente | "new" | "skip". */
export const runNotionImport = async (file: File, mapping: Record<string, string>) => {
  const form = new FormData();
  form.append("file", file);
  form.append("mapping", JSON.stringify(mapping));
  return api.post("/api/intranet/import", form, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 });
};
